










import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import BlackListForm from "./Form.vue";
import BlackList from "@/store/blacklists";

@Component({
  components: {
    "blacklist-form": BlackListForm
  }
})
export default class AppBlackListCreate extends Vue {
  isLoading: boolean = false;
  error: any = "";

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await BlackList.createOne(form);

      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("BlackList Created");
    } catch (error) {
      this.isLoading = false;
      // this.error = error.response.data.blacklist;
      this.$toasted.error(this.error);
    }
  }

  async onCancel() {
    this.$router.back();
  }
}
